import axios from "axios";
import { IFaqItem, IFaqResponse, IMeta } from "../types/faq";

interface IProps {
  language: string;
  id: string;
}

interface HRFiles {
  language: string;
  tag: string;
}

interface IPropsCollection {
  language: string;
  limit?: number;
  table?: string;
  subCategory?: string;
}
// Assuming these are in faq.ts or a similar type definitions file
export interface IFilesResponse {
  data: Array<{
    id: number;
    attributes: FileAttribute;
  }>;
  meta: {
    pagination: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export interface FileAttribute {
  Title: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  locale: string;
  file?: {
    data: FileData;
  };
}

export interface FileData {
  id: number;
  attributes: {
    name: string;
    alternativeText?: string;
    caption?: string;
    width?: number;
    height?: number;
    formats?: any;
    hash: string;
    ext: string;
    mime: string;
    size: number;
    url: string;
    previewUrl?: string;
    provider: string;
    provider_metadata?: any;
    createdAt: string;
    updatedAt: string;
  };
}


// Define the interfaces based on your provided JSON structure
export interface File {
  id: number;
  title: string;

  attributes: FileAttribute;

}
export interface FileAttribute {
  name: string;
  url: string;
  ext: string;
  mime: string;
  size: number;
}

export interface SectionItem {
  id: number;
  title: string;
  file: File;
}

export interface LibrarySection {
  id: number;
  title: string;
  files: File[];
}

interface IPropsPageCollection {
  language: string;
  page: number;
  pageSize: number;
}

export const getServices = async ({ limit = 3, language = "ar" }: IPropsCollection) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CMS}/api/services?_limit=${limit}&locale=${language}`
  );
  return response.data;

};
export const getMainSliderItems = async ({ language = "ar" }: IPropsCollection) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CMS}/api/main-slider-items?locale=${language}`
  );
  return response.data;

};



export const getSystems = async ({ limit = 3, language = "ar" }: IPropsCollection) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/internal-systems`, {
    params: {
      'sort': 'sort_order:DESC',          // Sort by 'id' in descending order
      locale: language,
      'pagination[page]': 1,           // Page number (1-based index)
      'pagination[pageSize]': limit,   // Limit per page
      _start: 0,      // Optional: Start index, default is 0 (first item)
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });
  return response.data;

};

export const getNewsItems = async ({ limit = 3, language = "ar" }: IPropsCollection) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/news-items`, {
    params: {
      'sort': 'id:DESC',          // Sort by 'id' in descending order
      locale: language,
      'pagination[page]': 1,           // Page number (1-based index)
      'pagination[pageSize]': limit,   // Limit per page
      _start: 0,      // Optional: Start index, default is 0 (first item)
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });

  return response.data;

};
export const getNewsItemsPerPage = async ({ limit, language, page = 1, pageSize = 5 }: { limit?: number; language: string; page?: number; pageSize?: number }) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/project-news-Items`, {
    params: {
      'sort': 'id:DESC',          // Sort by 'id' in descending order
      locale: language,
      'pagination[page]': page,           // Page number (1-based index)
      'pagination[pageSize]': pageSize,   // Limit per page
      _start: 0,      // Optional: Start index, default is 0 (first item)
      'filters[project]': [1, 2],  // Filter by division equal to 5

      populate: '*',  // Use this to populate all relational fields, including media
    },
  });

  return response.data;

};
export const getNewsItemsCat = async ({ limit = 3, language = "ar", subCategory = "0" }: IPropsCollection) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/news-items`, {
    params: {
      'sort': 'id:DESC',          // Sort by 'id' in descending order
      locale: language,
      'pagination[page]': 1,           // Page number (1-based index)
      'pagination[pageSize]': limit,   // Limit per page
      _start: 0,      // Optional: Start index, default is 0 (first item)
      populate: '*',  // Use this to populate all relational fields, including media
      'filters[division]': subCategory,  // Filter by division equal to 5

    },
  });

  return response.data;

};
export const getMessages = async ({ limit = 3, language = "ar" }: IPropsCollection) => {


  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/messages-centers`, {
    params: {
      '_sort': 'message_date:DESC',          // Sort by 'id' in descending order
      locale: language,
      'pagination[page]': 1,           // Page number (1-based index)
      'pagination[pageSize]': limit,   // Limit per page
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });


  return response.data;

};

// Helper to handle date issues (UTC vs local)
const getTodayISOString = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);  // Set time to start of the day (00:00:00)
  return today.toISOString();
};


export const getEvents = async ({
  limit = 3,
  language = "ar",
}: IPropsCollection) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_CMS}/api/events`,
      {
        params: {
          sort: "Date:ASC", // Sort events by publish date
          locale: language, // Set locale for translations
          "pagination[page]": 1, // Page number (1-based index)
          "pagination[pageSize]": 4, // Limit per page
          "filters[Date][$gte]": getTodayISOString(), // Filter events by today onwards
          populate: "*", // Populate relational fields (e.g., media)
        },
      }
    );

    return response.data;
  } catch (error) {
    // console.error("Error fetching events:", error.response || error.message);
    // throw error;
  }
};
export const getImageGalleries = async ({ language = "ar" }: IPropsCollection) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/image-galleries`, {
    params: {
      'sort': 'id:DESC',          // Sort by 'id' in descending order
      //   locale: language,
      'pagination[page]': 1,           // Page number (1-based index)
      'pagination[pageSize]': 100,   // Limit per page
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });



  return response.data;

};


export const getMenu = async ({ language = "ar" }: IPropsCollection) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CMS}/api/menu?locale=${language}`
  );
  return response.data;

};

export const getSocialLinks = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_CMS}/api/social-links`
  );
  return response.data;

};



export const getSingleImageGallery = async ({ language = "ar", id }: IProps) => {


  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/image-galleries/` + id, {
    params: {
      locale: language,

      populate: '*',  // Use this to populate all relational fields, including media
    },
  });


  return response.data;

};

export const getOneNewsItem = async ({ language = "ar", id }: IProps) => {


  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/news-items/` + id, {
    params: {
      locale: language,

      populate: '*',  // Use this to populate all relational fields, including media
    },
  });


  return response.data;

};
export const getOneNewsItemPage = async ({ language = "ar", id }: IProps) => {


  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/project-news-Items/` + id, {
    params: {
      locale: language,

      populate: '*',  // Use this to populate all relational fields, including media
    },
  });


  return response.data;

};
export const getOneService = async ({ language = "ar", id }: IProps) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CMS}/api/services/${id}?locale=${language}`
  );
  return response.data;

};

export const getOnePageItem = async ({ language = "ar", id }: IProps) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CMS}/api/pages/${id}?locale=${language}`
  );
  return response.data;

};

export const getOneDivisionItem = async ({ language = "ar", id }: IProps) => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/Divisions/` + id, {
    params: {
      locale: language,

      populate: '*',  // Use this to populate all relational fields, including media
    },
  });
  return response.data;
};

// export const getOneDivisionsItems = async ({ language = "ar" }: IProps) => {
//   const response = await axios.get(`${process.env.REACT_APP_CMS}/api/Divisions`, {
//     params: {
//       locale: language,
//       populate: '*',  // Use this to populate all relational fields, including media
//     },
//   });
//   return response.data;
// };

export const getDivisionsItems = async ({ language = "ar" }: IPropsCollection) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/Divisions`, {
    params: {
      'sort': 'id:DESC',          // Sort by 'id' in descending order
      locale: language,
      'pagination[page]': 1,           // Page number (1-based index)
      _start: 0,      // Optional: Start index, default is 0 (first item)
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });
  return response.data;

};

export const getGovernanceDocumentsItems = async ({ language = "ar" }: IPropsCollection) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/governance-documents`, {
    params: {
      'sort': 'id:DESC',          // Sort by 'id' in descending order
      locale: language,
      'pagination[page]': 1,           // Page number (1-based index)
      _start: 0,      // Optional: Start index, default is 0 (first item)
      //populate: '*',  // Use this to populate all relational fields, including media
    },
  });
  return response.data;

};

export const getOneGovernanceDocumentItem = async ({ language = "ar", id }: IProps) => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/governance-documents/` + id, {
    params: {
      locale: language,
      populate: 'governance_documents_files.file',  // Use this to populate all relational fields, including media
    },
  });
  return response.data;
};


export const getOneProjectItem = async ({ language = "ar", id }: IProps) => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/projects/` + id, {
    params: {
      locale: language,
      populate: {
        aboutProjectTitle: true,
        aboutProjectDescrption: true,
        section2Title: true,
        section2Description: true,
        projectNewsTitle: true,
        aboutProjectImage: '*',
        section2Image: '*',
        projectSliderImages: '*',
        localizations: {
          populate: {
            aboutProjectTitle: true,
            aboutProjectDescrption: true,
            section2Title: true,
            section2Description: true,
            projectNewsTitle: true,
            aboutProjectImage: '*',
            section2Image: '*',
            projectSliderImages: '*',
          }
        }
      }
    },
  });

  return response.data;
};



export const getOnePolicyItem = async ({ language = "ar", id }: IProps) => {


  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/policy-files`, {
    params: {
      locale: language,
      populate: '*',  // Use this to populate all relational fields, including media
      'filters[division]': id,  // Filter by division equal to 5

    },
  });

  return response.data;

};


export const getHRFiles = async ({ language = "ar", tag }: HRFiles) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/hr-files`, {
    params: {
      locale: language,
      populate: '*',  // Use this to populate all relational fields, including media
      'filters[tag]': tag,  // Filter by division equal to 5

    },
  });

  return response?.data;

};
//token
export const getDepartmentFiles = async ({ language = "ar", id }: IProps) => {
  // console.log('getDepartmentFiles');
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/departments/${id}`, {
    params: {
      locale: language,
      populate: 'department_files.file',
    },
  });
  return response?.data;
};

export const getHRAnnouncements = async ({ language = "ar" }) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/hr-announcements`, {
    params: {
      locale: language,
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });

  return response?.data;

};

export const getOrgStructure = async ({ language = "ar", id }: IProps) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CMS}/api/hr-files/${id}?populate=*`
  );
  return response.data;

};

export const getOneMagazinItem = async ({ language = "ar", id }: IProps) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CMS}/api/magazines/${id}`
  );
  return response.data;

};


export const getClients = async ({ language = "ar" }: IPropsCollection) => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/clients?locale=${language}`);
  return response.data;

};

export const getPartners = async ({ language = "ar" }: IPropsCollection) => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/partners?locale=${language}`);
  return response.data;

};

export const getContactInfo = async ({ language = "ar" }: IPropsCollection) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CMS}/api/contact-info?locale=${language}`
  );
  return response.data;

};


export const getBackgroundVideo = async () => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/api/contact-info`
  );
};



export const getInternalPortalHomeSides = async ({ language = "ar" }: IPropsCollection) => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/home-sliders`, {
    params: {
      locale: language,
      _sort: 'id:ASC',
      'pagination[page]': 1,           // Page number (1-based index)
      'pagination[pageSize]': 5,   // Limit per page
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });
  // Return response.data directly
  return response.data;
};

export const getInternalPortalAnnouncements = async ({ table = "announcements", language = "ar" }: IPropsCollection) => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/${table}`, {
    params: {
      _sort: 'id:ASC',
      'pagination[page]': 1,           // Page number (1-based index)
      'pagination[pageSize]': 20,   // Limit per page
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });


  return response.data;

};

export const getInternalPortalAnnouncementsASC = async ({ table = "announcements", language = "ar" }: IPropsCollection) => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/${table}?_sort=id:ASC&_limit=20`);
  return response.data;

};


export const getInternalPortalFaqs = async ({ subCategory = "1", language = "ar" }: IPropsCollection) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/Faq-questions`, {
    params: {
      locale: "ar",

      _sort: 'id:ASC',
      'filters[faq_category]': subCategory,  // Filter by division equal to 5

      populate: '*',  // Use this to populate all relational fields, including media
    },
  });
  return response.data;

};
export const getInternalPortalFaqsSection = async ({ subCategory = "1", language = "ar" }: IPropsCollection) => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/faq-categories`, {
    params: {
      locale: "ar",

      _sort: 'id:ASC',
      'filters[id]': subCategory,  // Filter by division equal to 5
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });
  return response.data;

};

export const getInternalPortalFaqsAllPerPage = async ({ language = "ar", page = 1, pageSize = 5 }: IPropsPageCollection): Promise<IFaqResponse> => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/project-faqs`, {
    params: {
      locale: language,
      _sort: "id:ASC",
      populate: "*",
      'filters[project]': [1, 2],  // Filter by division equal to 5

      "pagination[page]": page,
      "pagination[pageSize]": pageSize,
    },
  });
  return response.data; // This includes both `data` and `meta`
};
export const fetchLibraryDataPerPage = async ({ language = "ar", page = 1, pageSize = 5 }: IPropsPageCollection): Promise<IFilesResponse> => {



  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/project-files`, {
    params: {
      locale: language,
      populate: { file: true },  // Use this to populate all relational fields, including media
      _sort: "id:ASC",
      'filters[project]': [1, 2],  // Filter by division equal to 5

      "pagination[page]": page,
      "pagination[pageSize]": pageSize,
    },
  });
  return response.data; // This includes both `data` and `meta`
};

export const getInternalPortalFaqsAll = async ({ language = "ar" }: IPropsCollection): Promise<IFaqItem[]> => {


  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/Faq-questions`, {
    params: {
      locale: language,

      _sort: 'id:ASC',
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });
  return response.data.data;

};

export const fetchLibraryData = async (language: string): Promise<LibrarySection[]> => {

  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/libraries`, {
    params: {
      locale: language,
      populate: '*',  // Use this to populate all relational fields, including media
    },
  });

  // Transform the flat data into grouped by section
  // Create a map to hold sections and aggregate files under them
  const sectionsMap: { [key: number]: LibrarySection } = {};

  response.data.data.forEach((item: any) => {
    const { library_section, file, Title } = item.attributes;
    if (!sectionsMap[library_section.data.id]) {
      sectionsMap[library_section.data.id] = { id: library_section.data.id, title: library_section.data.attributes.title, files: [] };
    }
    file.data.attributes.name = Title;
    sectionsMap[library_section.data.id].files.push(file.data);
  });

  return Object.values(sectionsMap);
};


export const fetchLibraryDataCat = async (language: string, subCategory: string): Promise<LibrarySection[]> => {



  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/libraries`, {
    params: {
      locale: language,
      populate: '*',  // Use this to populate all relational fields, including media
      'filters[division]': subCategory,  // Filter by division equal to 5

    },
  });



  // Transform the flat data into grouped by section
  // Create a map to hold sections and aggregate files under them
  const sectionsMap: { [key: number]: LibrarySection } = {};

  response.data.data.forEach((item: any) => {
    const { library_section, file, Title } = item.attributes;
    if (!sectionsMap[library_section.data.id]) {
      sectionsMap[library_section.data.id] = { id: library_section.data.id, title: library_section.data.attributes.title, files: [] };
    }
    file.data.attributes.name = Title;
    sectionsMap[library_section.data.id].files.push(file.data);
  });

  return Object.values(sectionsMap);
};

export const fetchLibrarySections = async (language: string, subCategory: string): Promise<LibrarySection[]> => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/library-sections`, {
    params: {
      locale: language,
      //populate: '*',  // Use this to populate all relational fields, including media
      'populate[libraries][populate]': 'file',
      'filters[divisions]': subCategory,  // Filter by division equal to 5
      'sort': 'id:asc'
    },
  });

  return Object.values(response.data.data);
};


export const fetchLibrariesSectionsFiles = async (language: string, divisionid: string, company: string): Promise<LibrarySection[]> => {
  const response = await axios.get(`${process.env.REACT_APP_CMS}/api/libraries?locale=${language}&sort=id:asc&populate=divisions&populate=file&populate=library_section&filters[employees]=All&filters[employees]=${company}&filters[divisions]=${divisionid}&sort=sort:asc&filters[library_section][$notNull]=true`)
  const librariesData = response?.data?.data || [];

  const sectionsMap: { [key: number]: LibrarySection } = {};

  librariesData.forEach((item: any) => {
    const { library_section, file, Title } = item.attributes;
    if (!sectionsMap[library_section.data.id]) {
      sectionsMap[library_section.data.id] = { id: library_section.data.id, title: library_section.data.attributes.title, files: [] };
    }
    file.data.attributes.name = Title;
    sectionsMap[library_section.data.id].files.push(file.data);
  });

  return Object.values(sectionsMap);
};
